import { PerkVisualisation } from 'components/loyalty/models/PerkModel';
import { isString } from 'lib/typeguards';

export interface Award {
    _id: string;
    auto: boolean;
    isDonatable: boolean;
    isGlobal: boolean;
    isTier: boolean;
    maximumPointCashValue: number;
    perkId: string;
    points: AwardPoints;
    priority: string;
    redemptionMethod: string;
    template: AwardTemplate;
    tenantId: string;
    terms: string;
    title: string;
    token: string;
    userId: string;
    visualisation: PerkVisualisation;
    internalTitle?: string;
}

export enum AwardTemplate {
    AD_HOC = 'AD_HOC',
    PSEUDO_CURRENCY = 'PSEUDO_CURRENCY',
    STAMP_CARD = 'STAMP_CARD',
    CLUB = 'CLUB',
    LEVEL = 'LEVEL'
}

export const awardTemplateLabels = {
    AD_HOC: 'Ad Hoc',
    PSEUDO_CURRENCY: 'Pseudo currency',
    STAMP_CARD: 'Stamp card',
    CLUB: 'Audience',
    LEVEL: 'Level'
};

export interface AwardPoints {
    available?: number;
    initial: number;
    max: number;
    min: number;
    redemption: number;
    step: number;
}

// TODO: replace with real typeguard
export function isAward(item: any): item is Award {
    return (
        !!item &&
        isString(item.title) &&
        isString(item.tenantId) &&
        isString(item.userId) &&
        isString(item.template)
    );
}

export enum AwardExpiryLabelAnchorStyles {
    BOTTOM_RIGHT_CHIP = 'BOTTOM_RIGHT_CHIP',
    BOTTOM_MIDDLE_CHIP = 'BOTTOM_MIDDLE_CHIP',
    BOTTOM_LEFT_CHIP = 'BOTTOM_LEFT_CHIP',
    TOP_RIGHT_CHIP = 'TOP_RIGHT_CHIP',
    TOP_MIDDLE_CHIP = 'TOP_MIDDLE_CHIP',
    TOP_LEFT_CHIP = 'TOP_LEFT_CHIP',
    TOP_FULL_WIDTH_BAR = 'TOP_FULL_WIDTH_BAR',
    BOTTOM_FULL_WIDTH_BAR = 'BOTTOM_FULL_WIDTH_BAR'
}

export enum AwardExpiryLabelDetailStyles {
    BOTTOM_MIDDLE_CHIP = 'BOTTOM_MIDDLE_CHIP',
    TOP_MIDDLE_CHIP = 'TOP_MIDDLE_CHIP',
    TOP_FULL_WIDTH_BAR = 'TOP_FULL_WIDTH_BAR',
    BOTTOM_FULL_WIDTH_BAR = 'BOTTOM_FULL_WIDTH_BAR'
}

export enum AwardsScreenShapes {
    DOUBLE_RECTANGLE = 'DOUBLE_RECTANGLE',
    SINGLE_RECTANGLE = 'SINGLE_RECTANGLE',
    LARGE_SQUARE = 'LARGE_SQUARE',
    SMALL_SQUARE = 'SMALL_SQUARE'
}
